import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducers';

const storeEnhancers = compose(applyMiddleware(thunkMiddleware));

export default createStore(reducer, storeEnhancers);
